<script>
import html2pdf from 'html2pdf.js';

export default {
  data() {
    return {
      isPDFMode: false
    };
  },

  methods: {
    downloadPDF(title) {
      this.isPDFMode = true;
      const element = document.getElementById('pdf-generate');

      // Ensure all external images are fully loaded before generating the PDF
      const loadImages = () => {
        const images = Array.from(element.querySelectorAll('img'));
        const promises = images.map((img) => {
          return new Promise((resolve, reject) => {
            if (img.complete) {
              resolve();
            } else {
              img.onload = resolve;
              img.onerror = reject;
            }
          });
        });
        return Promise.all(promises);
      };

      loadImages()
        .then(() => {
          const opt = {
            margin: 0,
            filename: title,
            image: { type: 'jpeg', quality: 0.98 },

            html2canvas: {
              scale: 1.2,
              useCORS: true // Enable CORS to handle external images
            },
            jsPDF: { unit: 'in', format: 'a4', orientation: 'portrait' }
          };
          html2pdf()
            .from(element)
            .set(opt)
            .save();
        })
        .catch((error) => {
          console.error('Error loading images:', error);
        });

      setTimeout(() => {
        this.isPDFMode = false;
      }, 100);
    }
  }
};
</script>
